"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.parseQuiet = exports.parse = void 0;
var token_1 = require("../instruction/token");
var associated_token_account_1 = require("../instruction/associated-token-account");
var memo_1 = require("../instruction/memo");
var stake_1 = require("../instruction/stake");
var system_1 = require("../instruction/system");
var parse = function (ix) {
    if ("parsed" in ix) {
        var program = ix.program;
        switch (program) {
            case "system":
                return {
                    program: program,
                    title: "System",
                    instruction: (0, system_1.parseSystemInstruction)(__assign(__assign({}, ix), { program: program }))
                };
            case "spl-associated-token-account":
                return {
                    program: program,
                    title: "Associated Token Account",
                    instruction: (0, associated_token_account_1.parseAssociatedTokenAccountInstruction)(__assign(__assign({}, ix), { program: program }))
                };
            case "spl-memo":
                return {
                    program: program,
                    title: "Memo",
                    instruction: (0, memo_1.parseSplMemoInstruction)(__assign(__assign({}, ix), { program: program }))
                };
            case "stake":
                return {
                    program: program,
                    title: "Stake",
                    instruction: (0, stake_1.parseStakeInstruction)(__assign(__assign({}, ix), { program: program }))
                };
            case "spl-token":
                return {
                    program: program,
                    title: "Token",
                    instruction: (0, token_1.parseSplTokenInstruction)(__assign(__assign({}, ix), { program: program }))
                };
            default:
                return unknown();
        }
    }
    return unknown();
};
exports.parse = parse;
var parseQuiet = function (ix) {
    try {
        return (0, exports.parse)(ix);
    }
    catch (_) {
        return unknown();
    }
};
exports.parseQuiet = parseQuiet;
function unknown() {
    return {
        program: "unknown",
        title: "Unknown",
        instruction: undefined
    };
}
//# sourceMappingURL=parser.js.map